<template>
  <v-card :to="item.to" flat class="articles-highlight-card relative">
    <img :src="item.img + '?resize=1&w=700'" class="d-block" width="100%" />
    <div
      class="
        articles-highlight-caption
        d-flex
        justify-end
        align-start
        flex-column
        pa-5 pa-sm-7 pa-md-9
      "
    >
      <div
        class="
          articles-highlight-title
          white--text
          font-weight-bold
          text-h6 text-sm-h5 text-md-h4
        "
      >
        <span class="font-barlow">
          {{ item.title }}
        </span>
      </div>
      <div class="d-flex align-baseline mt-4">
        <v-icon color="white" size="20">far fa-calendar</v-icon>
        <span
          class="
            articles-highlight-date
            white--text
            ml-2
            text-uppercase text-body-2 text-sm-body-1
          "
        >
          {{ item.date }}
        </span>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.articles-highlight {
  &-card {
    position: relative;
    img {
      height: 100%;
      object-fit: cover;
      aspect-ratio: 653 / 377;
      border-radius: 8px !important;
    }
  }
  &-caption {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    top: 0;
  }
  &-title {
    text-shadow: 2px 2px 0px rgba(0, 0, 0, 0.25);
    line-height: 120%;
  }
}
</style>
